"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var HexadecimalIdentifierNamesGenerator_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.HexadecimalIdentifierNamesGenerator = void 0;
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../../container/ServiceIdentifiers");
const AbstractIdentifierNamesGenerator_1 = require("./AbstractIdentifierNamesGenerator");
const NumberUtils_1 = require("../../utils/NumberUtils");
const Utils_1 = require("../../utils/Utils");
let HexadecimalIdentifierNamesGenerator = HexadecimalIdentifierNamesGenerator_1 = class HexadecimalIdentifierNamesGenerator extends AbstractIdentifierNamesGenerator_1.AbstractIdentifierNamesGenerator {
    constructor(randomGenerator, options) {
        super(randomGenerator, options);
    }
    generateNext(nameLength) {
        return this.generateNextName(nameLength, (name) => this.isValidIdentifierName(name));
    }
    generateForGlobalScope(nameLength) {
        return this.generateForGlobalScopeInternal(nameLength, (name) => this.isValidIdentifierName(name));
    }
    generateForGlobalScopeWithAllScopesValidation(nameLength) {
        return this.generateForGlobalScopeInternal(nameLength, (name) => this.isValidIdentifierNameInAllScopes(name));
    }
    generateForLexicalScope(lexicalScopeNode, nameLength) {
        return this.generateNext(nameLength);
    }
    generateForLabel(label, nameLength) {
        return this.generateNext(nameLength);
    }
    generateForGlobalScopeInternal(nameLength, validationFn) {
        const identifierName = this.generateNextName(nameLength, validationFn);
        return `${this.options.identifiersPrefix}${identifierName}`.replace('__', '_');
    }
    generateNextName(nameLength, validationFn) {
        const rangeMinInteger = 10000;
        const rangeMaxInteger = 99999999;
        const prefixLength = Utils_1.Utils.hexadecimalPrefix.length;
        const baseNameLength = (nameLength !== null && nameLength !== void 0 ? nameLength : HexadecimalIdentifierNamesGenerator_1.baseIdentifierNameLength) + prefixLength;
        let identifierName = '';
        let isValid = false;
        for (let attempts = 0; !isValid; attempts++) {
            this.checkGenerationAttempts(attempts);
            const randomInteger = this.randomGenerator.getRandomInteger(rangeMinInteger, rangeMaxInteger);
            const hexadecimalNumber = NumberUtils_1.NumberUtils.toHex(randomInteger);
            const baseIdentifierName = hexadecimalNumber.slice(0, baseNameLength);
            identifierName = `_${baseIdentifierName}`;
            isValid = validationFn(identifierName);
        }
        this.preserveName(identifierName);
        return identifierName;
    }
};
exports.HexadecimalIdentifierNamesGenerator = HexadecimalIdentifierNamesGenerator;
HexadecimalIdentifierNamesGenerator.baseIdentifierNameLength = 6;
exports.HexadecimalIdentifierNamesGenerator = HexadecimalIdentifierNamesGenerator = HexadecimalIdentifierNamesGenerator_1 = __decorate([
    (0, inversify_1.injectFromBase)(),
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IRandomGenerator)),
    __param(1, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IOptions)),
    __metadata("design:paramtypes", [Object, Object])
], HexadecimalIdentifierNamesGenerator);
